import type { AxiosRequestConfig } from 'axios';
import { monitoringInstance } from '@/shared/api/api-instances/monitoring/api-instance';
import {
  DSLFieldCaps,
  DSLFieldCapsDTO,
  DSLResponse,
  DSLResponseDTO,
} from '@/shared/api/opensearch';
import { ValidateResponse } from '@/shared/api/validate-response';
import type {
  OpensearchPreviewQuery,
  OpensearchQuery,
} from '../model/opensearch-query';
import { z } from 'zod/v4';

const baseURLOverride = {
  baseURL: '/api/monitoring/v4',
};

export class OpensearchAPI {
  @ValidateResponse(z.array(DSLResponseDTO()))
  static getSearch(
    index: string,
    payload: OpensearchQuery,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.post<DSLResponse>(
      `/opensearch/proxy/${index}/search`,
      payload,
      {
        ...baseURLOverride,
        ...options,
      },
    );
  }
  @ValidateResponse(z.array(DSLResponseDTO()))
  static getSearchPreview(
    index: string,
    payload: OpensearchPreviewQuery,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.post<DSLResponse>(
      `/opensearch/proxy/${index}/search/preview`,
      payload,
      {
        ...baseURLOverride,
        ...options,
      },
    );
  }
  @ValidateResponse(DSLFieldCapsDTO)
  static getFieldCaps(index: string, options?: AxiosRequestConfig) {
    return monitoringInstance.get<DSLFieldCaps>(
      `/opensearch/proxy/${index}/field_caps`,
      {
        ...baseURLOverride,
        params: { fields: '*' },
        ...options,
      },
    );
  }
}